<template>
    <div class="row">
        <div class="col-md-12">
            <nav
                aria-label="Page navigation example"
                class="d-flex align-self-end"
            >
                <ul class="pagination ml-auto mb-0">
                    <li class="page-item previous">
                        <a
                            class="page-link"
                            :class="{ disabled: currentPage == 1 }"
                            @click.prevent="
                                changePage(
                                    selected_page > 1 ? selected_page - 1 : 1
                                )
                            "
                            ><img
                                src="/maincss/images/previous_arrow.svg"
                                alt=""
                                class="mr_10"
                            />
                            Previous</a
                        >
                    </li>
                    <li
                        class="page-item"
                        v-for="page in pages"
                        :data-test="`page-link-${page}`"
                        :key="page"
                        :class="paginationClass(page)"
                        @click.prevent="changePage(page)"
                    >
                        <a class="page-link" href v-text="page" />
                    </li>

                    <li class="page-item next active">
                        <a
                            class="page-link"
                            :class="{ disabled: currentPage == pages.length }"
                            @click.prevent="
                                changePage(
                                    selected_page < pages.length
                                        ? selected_page + 1
                                        : pages.length
                                )
                            "
                            >Next
                            <img
                                src="/maincss/images/next_arrow.svg"
                                alt=""
                                class="ml_10"
                        /></a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: "VPagination",
    props: {
        pages: {
            type: Array,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            selected_page: 1
        };
    },
    methods: {
        changePage(goToPage) {
            if (goToPage === this.currentPage) return;
            this.selected_page = goToPage;
            this.$emit("update:currentPage", goToPage);
        },
        paginationClass(page) {
            return {
                "page-item": true,
                active: this.currentPage === page
            };
        }
    }
};
</script>
